import { createClient } from '@supabase/supabase-js';

// Log environment variables for debugging
console.log('[Supabase] Initializing Supabase client...');
console.log(`[Supabase] Supabase URL: ${import.meta.env.VITE_SUPABASE_URL ? '✅ Set' : '❌ Missing'}`);
console.log(`[Supabase] Supabase Anon Key: ${import.meta.env.VITE_SUPABASE_ANON_KEY ? '✅ Set' : '❌ Missing'}`);

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  const errorMsg = '[Supabase] ❌ Missing Supabase environment variables. Please check your .env file.';
  console.error(errorMsg);
  throw new Error(errorMsg);
}

// Create Supabase client with CORS and enhanced configuration
const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
    storage: typeof window !== 'undefined' ? window.localStorage : undefined,
  },
  global: {
    headers: { 
      'X-Client-Info': 'esports-registration',
      'Access-Control-Allow-Origin': '*',
      'Access-Control-Allow-Headers': 'authorization, x-client-info, apikey, content-type',
    },
  },
});

// Create admin client for server-side operations
const adminSupabase = createClient(
  supabaseUrl,
  import.meta.env.VITE_SUPABASE_SERVICE_ROLE_KEY || supabaseAnonKey,
  {
    auth: {
      autoRefreshToken: false,
      persistSession: false,
      detectSessionInUrl: false,
    },
    global: {
      headers: {
        'X-Client-Info': 'esports-admin',
        'Authorization': `Bearer ${import.meta.env.VITE_SUPABASE_SERVICE_ROLE_KEY || supabaseAnonKey}`,
      },
    },
  }
);

// Function to get admin client with elevated privileges
export const getAdminClient = () => {
  return adminSupabase;
};

// Add a response interceptor for logging
const { data: authListener } = supabase.auth.onAuthStateChange((event, session) => {
  console.log(`[Supabase Auth] ${event}`, { session });
});

// Log database connection status
supabase
  .from('squads')
  .select('*', { count: 'exact', head: true })
  .then(({ error }) => {
    if (error) {
      console.error('[Supabase] ❌ Connection test failed:', error);
    } else {
      console.log('[Supabase] ✅ Successfully connected to Supabase');
    }
  });

export { supabase };
